export const YUSA_OVERNIGHT_CAMP_GET_TOTAL_STAFF_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_GET_TOTAL_STAFF_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_GET_TOTAL_STAFF_FAILURE =
  'YUSA_OVERNIGHT_CAMP_GET_TOTAL_STAFF_FAILURE';

export const YUSA_OVERNIGHT_CAMP_POST_TOTAL_STAFF_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_POST_TOTAL_STAFF_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_POST_TOTAL_STAFF_FAILURE =
  'YUSA_OVERNIGHT_CAMP_POST_TOTAL_STAFF_FAILURE';

export const YUSA_OVERNIGHT_CAMP_WAGES_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_WAGES_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_WAGES_FAILURE =
  'YUSA_OVERNIGHT_CAMP_WAGES_FAILURE';

export const YUSA_OVERNIGHT_CAMP_WAGES_LIST_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_WAGES_LIST_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_WAGES_LIST_FAILURE =
  'YUSA_OVERNIGHT_CAMP_WAGES_LIST_FAILURE';

export const YUSA_OVERNIGHT_CAMP_ROLES_LIST_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_ROLES_LIST_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_ROLES_LIST_FAILURE =
  'YUSA_OVERNIGHT_CAMP_ROLES_LIST_FAILURE';
